import script from "./CustomBackToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomBackToTop.vue?vue&type=script&setup=true&lang=js"

import "./CustomBackToTop.vue?vue&type=style&index=0&id=5a3fe052&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3fe052"]])

export default __exports__